/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { useSession } from "../context/AuthContext";
import StudentTaskViewer from "../components/dashboard/StudentTaskViewer";
import api from "../services/api";

export default function TaskDetail() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const targetUserId = searchParams.get("userId");
  const { data: session } = useSession();
  const [taskData, setTaskData] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const effectiveUserId = targetUserId || (session?.user as any)?.id;
    if (effectiveUserId && id) {
      api.get(`/submissions/single/${id}/${effectiveUserId}?t=${Date.now()}`)
        .then(res => {
          setTaskData(res.data);
        })
        .catch(err => {
          console.error(err);
          setError("Failed to load this task. Please try again.");
        });
    }
  }, [session, id, targetUserId]);

  if (error) {
    return (
      <div className="bg-red-500/10 border border-red-500/20 p-8 rounded-3xl backdrop-blur-md shadow-sm">
        <h1 className="text-2xl font-black text-red-500">Error</h1>
        <p className="text-sm text-red-400 mt-2">{error}</p>
      </div>
    );
  }

  if (!taskData) {
    return (
      <div className="min-h-[400px] flex flex-col items-center justify-center text-on-surface flex-col gap-4">
        <span className="material-symbols-outlined text-4xl animate-spin">refresh</span>
        <p className="text-sm font-bold uppercase tracking-widest text-slate-500">Loading task details...</p>
      </div>
    );
  }

  return (
    <div className="w-full">
      <StudentTaskViewer {...taskData} />
    </div>
  );
}
